module.exports = __webpack_public_path__ + "img/maze.5903b0b4.svg";